<div class="selectContainer">
  <div class="slInputWrap">
    @if (showUnequalOption) {
      <div class="dropdownEqualOperator">
        <his-search-select-operator
          [widget]="widget">
        </his-search-select-operator>
      </div>
    }

    <p-autoComplete #inputElement
      [inputId]="uid"
      [hisDdKey]="widget.label"
      [hisDdSearchCriterion]="true"
      [ngModel]="selectedOptions"
      [suggestions]="filteredSelectList"
      [minLength]="minLength"
      [dropdown]="showDropdownIcon"
      [forceSelection]="true"
      (completeMethod)="filterSelectList($event)"
      (onSelect)="addSelectedElement($event)"
      optionLabel="nonexistingdummy"> <!-- clear input field after selection -->

      <ng-template let-item pTemplate="item">
        {{item.label}}
      </ng-template>
    </p-autoComplete>
  </div>
  <div class="unsichtbar">{{'common.components.selectManyPicklist.selected' | hisUi}}:</div>
  <ng-container class="selectedOptionsList">
    @if (selectedOptions.length > 0) {
      <p-dataView [value]="selectedOptions" styleClass="selectedDataContainer" [emptyMessage]="'&nbsp;'">
        <ng-template let-selectedOptions #list>
          <div class="p-grid p-grid-nogutter">
            <ul>
              @for (selectedOption of selectedOptions; track selectedOption; let first = $first) {
                <li class="selectedDataRow">
                  {{selectedOption.label}}
                  <button type="button" (click)="$event.stopPropagation(); deleteSelectedOption(selectedOption);" hisImage="PANEL_CLOSE" class="icon deleteSelectedOption" [title]="'view.controls.remove' | hisUi"></button>
                </li>
              }
            </ul>
          </div>
        </ng-template>
      </p-dataView>
    }
  </ng-container>
</div>
